$(document).ready(function(){
    $('.single_add_to_cart_button').on('click', function(e){
        let event_target_element = e.target;
        // track add to cart events for products on product detail pages
        if ( event_target_element.closest( '.single_add_to_cart_button:not(.disabled)' ) ) {
            const product_form = event_target_element.closest( 'form.cart' );
            if ( !product_form ) {
                return true;
            }

            let product_variant_id = product_form.querySelectorAll( '[name=variation_id]' );
            let product_is_grouped = product_form.classList && product_form.classList.contains( 'grouped_form' );

            if ( product_variant_id.length > 0 ) {
                if ( gtm4wp_last_selected_product_variation ) {
                    const qty_el = product_form.querySelector( '[name=quantity]' );
                    gtm4wp_last_selected_product_variation.quantity = (qty_el && qty_el.value) || 1;

                    gtm4wp_push_ecommerce( 'add_to_cart', [ gtm4wp_last_selected_product_variation ], {
                        'currency': gtm4wp_currency,
                        'value': (gtm4wp_last_selected_product_variation.price * gtm4wp_last_selected_product_variation.quantity).toFixed(2)
                    });
                }
            } else if ( product_is_grouped ) {
                const products_in_group = document.querySelectorAll( '.grouped_form .gtm4wp_productdata' );
                let products = [];
                let sum_value = 0;

                products_in_group.forEach( function( product_data_el ) {
                    const productdata = gtm4wp_read_json_from_node(product_data_el, 'gtm4wp_product_data', ['productlink']);
                    if ( !productdata ) {
                        return true;
                    }

                    const product_qty_input = document.querySelectorAll( 'input[name=quantity\\[' + productdata.internal_id + '\\]]' );
                    if ( product_qty_input.length > 0 ) {
                        product_qty = (product_qty_input[0] && product_qty_input[0].value) || 1;
                    } else {
                        return true;
                    }

                    if ( 0 == product_qty ) {
                        return true;
                    }
                    productdata.quantity = product_qty;

                    delete productdata.internal_id;

                    products.push( productdata );
                    sum_value += productdata.price * productdata.quantity;
                });

                if ( 0 == products.length ) {
                    return true;
                }

                gtm4wp_push_ecommerce( 'add_to_cart', products, {
                    'currency': gtm4wp_currency,
                    'value': sum_value.toFixed(2)
                });
            } else {
                const product_data_el = product_form.querySelector( '[name=gtm4wp_product_data]' );
                if ( !product_data_el ) {
                    return true;
                }

                let productdata = gtm4wp_read_from_json( product_data_el.value );
                productdata.quantity = product_form.querySelector( '[name=quantity]' ) && product_form.querySelector( '[name=quantity]' ).value;
                if ( isNaN( productdata.quantity ) ) {
                    productdata.quantity = 1;
                }

                gtm4wp_push_ecommerce( 'add_to_cart', [ productdata ], {
                    'currency': gtm4wp_currency,
                    'value': productdata.price * productdata.quantity
                });
            }
        }
    })
})